import { z } from 'zod';

/** Generic error envelope returned by the backend (see error-handler). */
export const apiErrorSchema = z.object({
  error: z.string(),
  message: z.string(),
  details: z.unknown().optional(),
});
export type ApiError = z.infer<typeof apiErrorSchema>;
